class BankAccountMappingViewController extends MUIViewController
{
    static newInstance(): BankAccountMappingViewController {
        let vc = new BankAccountMappingViewController("bank-account-mapping-view");
        vc.initWithResource("layout/setup/BankAccountMappingView.html");
        return vc;
    }

    private saveButton: MUIButton = null;
    private tableView: UITableView = null;

    private _mappingInfoItems: IntegratorMappingInfo[] = [];

    viewDidLoad() {
        super.viewDidLoad();

        this.saveButton = MUIOutlet(this, "save-btn", "MUIButton");
        this.saveButton.setAction(this, function() {
            DBHelper.saveMainContext();
        });

        this.tableView = MUIOutlet(this, "table-view", "UITableView");
        this.tableView.dataSource = this;
        this.tableView.delegate = this;
    }

    viewWillAppear(animate?) {
        super.viewWillAppear(animate);
        this.fetchedResultsController = null;
        this.tableView.reloadData();
    }

    numberOfSections(tableview: UITableView) {
        return this.fetchedResultsController.sections.length;
    }

    numberOfRowsInSection(tableview: UITableView, section: number) {
        let sec = this.fetchedResultsController.sections[section];
        return sec.numberOfObjects();
    }

    titleForHeaderInSection(tableView: UITableView, section: number): string {
        let ip = MIOIndexPath.indexForRowInSection(0, section);
        let item = this.fetchedResultsController.objectAtIndexPath(ip) as BankAccount;
        return item.bank.name;
    }

    cellAtIndexPath(tableview: UITableView, indexPath: MIOIndexPath) {
        let cell = tableview.dequeueReusableCellWithIdentifier("BankAccountMappingCell") as BankAccountMappingCell;
        let item = this.fetchedResultsController.objectAtIndexPath(indexPath) as BankAccount;
        cell.item = item;
        return cell;
    }

    didSelectCellAtIndexPath(tableView: UITableView, indexPath: MIOIndexPath) {
        // selection handled inline via cell controls
    }

    private _fetchedResultsController: MIOFetchedResultsController = null;
    set fetchedResultsController(value) {
        if (value == null && this._fetchedResultsController != null)
            this._fetchedResultsController.delegate = null;
        this._fetchedResultsController = value;
    }

    get fetchedResultsController() {
        if (this._fetchedResultsController != null) return this._fetchedResultsController;

        let ad = MUIWebApplication.sharedInstance().delegate;
        let sortDescriptors = [
            MIOSortDescriptor.sortDescriptorWithKey("bank.name", true),
            MIOSortDescriptor.sortDescriptorWithKey("info.title", true)
        ];
        let fetchRequest = DBHelper.listFetchRequestWithEntityName("BankAccount", sortDescriptors, null);
        fetchRequest.relationshipKeyPathsForPrefetching = ["bank", "info", "mappingInfo"];

        let frc = new MIOFetchedResultsController();
        frc.initWithFetchRequest(fetchRequest, ad.managedObjectContext, "bank.name");
        frc.delegate = this;
        frc.performFetch();

        this._fetchedResultsController = frc;
        return this._fetchedResultsController;
    }

    controllerDidChangeContent(controller) {
        this.tableView.reloadData();
    }
}
